define((require) => {
    "use strict";

    const Backbone = require("backbone");

    /**
     * Describes a font abstraction.
     *
     * @class FontDescriptor
     *
     * @see FontDescriptorCollection
     *
     * @author Kim
     */
    return Backbone.Model.extend({

        defaults: {

            /**
             * @type {String}
             */
            name: null,

            /**
             * @type {String}
             */
            family: null,

            /**
             * @type {String}
             */
            variations: null,

            /**
             * @type {FontProvider}
             */
            provider: null,

            /**
             * Object for storing specific font provider/vendor information.
             *
             * @type {Object}
             */
            data: null
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/data/fonts/FontDescriptor.js